import React, { useState, useEffect } from 'react';
import { Form, Button, Col, Row, Card } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import {
  getBoxFolderOfEmpById,
  updateBoxFolderOfEmp,
} from '../../../../services/BoxFolderOfEmpService';
import AsyncSelect from 'react-select/async';
import { getUsersSearch } from '../../../../services/BoxService';
import { employeeSearchList } from '../../../../store/selectors/BoxSelectors';
import { connect, useDispatch } from 'react-redux';

import { useForm, Controller } from 'react-hook-form';
import { employeeSearchAction } from '../../../../store/actions/BoxActions';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const UpdateBoxFolderOfEmp = ({ employeeList }) => {
  const [email, setEmail] = useState('');
  const [folderId, setFolderId] = useState('');
  const [defaultEmployeeList, setEmpListDefault] = useState(employeeList);
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchFolder = async () => {
      try {
        const folder = await getBoxFolderOfEmpById(id);
        if (folder) {
          getUsersSearch(folder.email.split('.')[0])
            .then((response) => {
              const options = response.data.map((employee) => ({
                value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
                label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
                email: employee.email,
              }));
              setEmpListDefault(options);
            })
            .catch((error) => {
              console.error('Error fetching employee data 2', error);
            });
        }
        setEmail(folder.email);
        setFolderId(folder.folderId);
      } catch (error) {
        console.error('Error fetching Box Folder of Emp details', error);
      }

      dispatch(employeeSearchAction(''));
    };

    fetchFolder();
  }, [id]);

  const loadOptions = (inputValue, callback) => {
    if (!inputValue) {
      callback([]);
      return;
    }
    getUsersSearch(inputValue)
      .then((response) => {
        const options = response.data.map((employee) => ({
          value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          email: employee.email,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error('Error fetching employee data', error);
        callback([]);
      });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateBoxFolderOfEmp(id, { email, folderId });
      // Show success toast notification
      toast.success('Box Folder updated Successfully!', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000, // Closes after 3 seconds
      });
      // Delay navigation to ensure toast is visible
      setTimeout(() => {
        navigate('/settings/box-folders/');
      }, 3000);
    } catch (error) {
      console.error('Error updating Box Folder of Emp', error);
    }
  };

  return (
    <div>
      <Card>
        <h2>Update Box Folder of Emp</h2>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col>
              <Form.Group as={Col} className="mb-3" controlId={`email`}>
                <Form.Label>Employee</Form.Label>
                <AsyncSelect
                  value={defaultEmployeeList.find((e) => e.email === email)}
                  cacheOptions
                  loadOptions={loadOptions}
                  defaultOptions={defaultEmployeeList}
                  placeholder="Select employee..."
                  className={`react-select-container`}
                  classNamePrefix="react-select"
                  onChange={(selectedOption) => {
                    setEmail(selectedOption.email);
                  }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="folderId">
                <Form.Label>Folder ID</Form.Label>
                <Form.Control
                  type="text"
                  value={folderId}
                  onChange={(e) => setFolderId(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <div className="d-flex justify-content-end">
            <Button className="m-2" variant="primary" type="submit">
              Update Folder
            </Button>
          </div>
        </Form>
      </Card>
      <ToastContainer />
    </div>
  );
};
const mapStateToProps = (state) => ({
  employeeList: employeeSearchList(state),
});

export default connect(mapStateToProps, {})(UpdateBoxFolderOfEmp);
